import { Text } from 'foundations-components/components/Text';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export const Caption = ({
  children,
  childMarginInlineStart,
  childTruncateLength,
  onClick
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    "data-test-id": "AvatarDisplay-truncateString-children",
    marginInlineStart: childMarginInlineStart,
    children: /*#__PURE__*/_jsx(TruncateString, {
      onClick: onClick,
      maxWidth: childTruncateLength,
      "data-test-id": "AvatarDisplay-truncateString",
      children: children
    })
  });
};